import axios from "axios";
import HTTP from "./http";

export default {
    getStartAgents: (payload) => axios.get(HTTP.START_CAR_AGENT, { params: { ...payload } }),
    getStartAgentMessages: (payload) => axios.get(HTTP.START_CAR_AGENT_MESSAGE, { params: { ...payload } }) ,
    deleteStartAgent: (payload) => axios.delete(HTTP.START_CAR_AGENT, { params: { ...payload } }),
    addStartAgent: (payload) => axios.post(HTTP.START_CAR_AGENT, { ...payload }),
    editStartAgent: (payload) => axios.patch(HTTP.START_CAR_AGENT, { ...payload }),
    sendMessage: (payload) => axios.post(HTTP.START_CAR_MESSAGE, { ...payload })
}